import { render, staticRenderFns } from "./contract-aligner.vue?vue&type=template&id=95aeb04e&"
import script from "./contract-aligner.vue?vue&type=script&lang=js&"
export * from "./contract-aligner.vue?vue&type=script&lang=js&"
import style0 from "./contract-aligner.vue?vue&type=style&index=0&id=95aeb04e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports